import React from 'react';
import ArticleCard from "./article-card";

/**
 * Class to handle the visible articles pane.
 */
export default class VisibleArticles extends React.Component {

    constructor(props) {
        super(props)
    }

    /**
     * Render the visible articles pane.
     */
    render() {
        return (
            <div className='c-h-category-related-articles__visible-articles'>
                {this.props.visibleArticles.map((article, i) => 
                    <ArticleCard 
                        key={i}
                        image={article.image}
                        categoryName={article.category_name}
                        readTime={article.read_time}
                        title={article.title}
                        excerpt={article.excerpt}
                        publishDate={article.publish_date}
                        url={article.url}/>
                )}
            </div>
        )
    }
}